module.exports = "<ubg-project-markup [id]=\"id\" [left]=\"original\" [right]=\"fassung\"></ubg-project-markup>"